// @flow
export const SERVER_ADDRESS = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/*
  successCallback: (data) => {}
  errorCallback: (err) => {}
*/
export function fetchPost(
  url: string,
  body: Object,
  successCallback: Function,
  errorCallback: Function,
) {
  fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(body),
    credentials: 'include',
  })
    .then((response) => {
      if (response.ok) {
        (response.json())
          .then(successCallback)
          .catch(successCallback);
      } else if (response.status === 401) {
        errorCallback({ message: 'Unauthorized access' });
      } else {
        (response.json()) // if error is JSON, parse error first
          .then(errorCallback)
          .catch(errorCallback);
      }
    });
}

export function fetchGet(
  url: string,
  successCallback: Function,
  errorCallback: Function,
) {
  fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'GET',
    credentials: 'include',
  })
    .then((response) => {
      if (response.ok) {
        (response.json())
          .then(successCallback)
          .catch(successCallback);
      } else {
        (response.json())
          .then(errorCallback)
          .catch(errorCallback);
      }
    });
}



// WEBPACK FOOTER //
// ./client/src/util/actionsUtil.js